import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import SwitchButton from "../Reusable/SwitchButton";

const BranchList = (props: any) => {
  const { handleIsActive } = props;
  console.log("orsf");
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Contact",
      accessorKey: "primary_contact",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "primary_email",
      cell: NACell,
    },
    {
      header: "Warehouse",
      accessorKey: "warehouse.name",
      cell: NACell,
    },
    {
      header: "Branch Manager",
      accessorKey: "manager.name",
      cell: NACell,
    },
  ];

  return (
    <DataTable
      url={APIS.BRANCH}
      queryKey={"branch"}
      columns={defaultColumns}
      addNewPagePath={""}
      tableName={"Branch"}
    />
  );
};

export default BranchList;
